import { Component } from '@angular/core';
import { Carousel } from "../../shared/components/carousel/carousel";
import { CompanyList } from "../../shared/components/company/company-list/company-list";

@Component({
  selector: 'app-home',
  imports: [
    Carousel, 
    CompanyList,
],
  templateUrl: './home.html',
  styleUrl: './home.scss'
})
export class Home {}